import { CacheKeysTables } from "../constants/keyCache";

export const getQueryCacheForTable = ({
  mainCacheKey,
  selectedTeam,
  playersGroup,
  page,
  recordsPerPage,
  sortBy,
  sortOrder,
  playerNameSearch = '',
}) => {
  const teamIdentifier = selectedTeam._id ?? selectedTeam.__name;
  const secondaryCacheOpts =  [teamIdentifier, `group-${playersGroup}`];
  if (playerNameSearch !== ''){
    secondaryCacheOpts.push(`player-${playerNameSearch}`);
  }

  const cacheKey = CacheKeysTables(mainCacheKey,secondaryCacheOpts, {
    page,
    recordsPerPage,
    sortBy: sortBy,
    sortOrder: sortOrder
  },);

  return {
    cacheKey,
    secondaryCacheOpts,
    teamIdentifier,
  }
}
